import React from 'react';
import CategoryImages from './CategoryImages';
import { storageAvailable } from '../../common/storageAvailable';

export default class PopUpCategoryNavigation extends React.Component {
  render() {
    var isLocalStorage = storageAvailable('localStorage');
    return (
      <div className="outer-div-popup">
        <div className="image-div-popup">
          <CategoryImages
            category={
              !!(
                isLocalStorage &&
                localStorage.getItem('categoryClicked') != '' &&
                localStorage.getItem('categoryClicked') != null
              )
            }
          />
        </div>
      </div>
    );
  }
}
